import { Injectable } from '@angular/core';
import { ConsentAdminApiService, ListScopesResponse, ScopeInterface } from '@vendasta/sso';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { Scope } from './scope';

function scopesFromAPI(scope: ScopeInterface): Scope {
  // interfaces don't match, set manually
  return {
    id: scope.id,
    name: scope.name,
    description: scope.description,
    created: scope.created,
    updated: scope.updated,
  };
}

@Injectable()
export class Oauth2ScopesService {
  constructor(private consentAdminService: ConsentAdminApiService) {}

  listScopes(): Observable<Scope[]> {
    // getting all scopes, paging only on results
    return this.consentAdminService.listScopes({ pageSize: 9999 }).pipe(
      map((resp: ListScopesResponse) => resp.scopes.map(scopesFromAPI)),
      take(1),
    );
  }

  createScope(id, name, description: string): Observable<null> {
    return this.consentAdminService.createScope({ id, name, description }).pipe(
      map(() => null),
      take(1),
    );
  }

  getScope(id: string): Observable<Scope> {
    return this.consentAdminService.getMultiScope({ scopeIds: [id] }).pipe(
      filter((resp) => !!resp && resp.scopes.length > 0),
      map((resp) => resp.scopes[0].scope),
      take(1),
    );
  }

  updateScope(scope: Scope): Observable<null> {
    return this.consentAdminService
      .updateScope({
        scopeId: scope.id,
        mutations: [{ name: scope.name }, { description: scope.description }],
      })
      .pipe(
        map(() => null),
        take(1),
      );
  }
}
